import React from 'react'
import Select from 'react-select'
import axios from 'axios'
import {
  concat,
  differenceWith,
  filter,
  includes,
  isEmpty,
  isEqual,
  lowerCase,
  map,
  some,
  startCase,
  truncate,
  unionWith,
  values
} from 'lodash'

import Alert from 'Components/Alert'
import ErrorList from 'Components/ErrorList'
import Modal from 'Components/Modal'
import { cloudhelpGet, cloudhelpPatch } from 'Utilities/CloudHelp'

// Due to react-select version quirks, this must be
// a full component instead of a functional one
class ImpactConcernOption extends React.Component {
  handleMouseDown = (event) => {
    const { onSelect, option } = this.props

    event.preventDefault()
    event.stopPropagation()

    onSelect(option, event)
  }

  handleMouseEnter = (event) => {
    const { onFocus, option } = this.props

    onFocus(option, event)
  }

  handleMouseMove = (event) => {
    const { isFocused, onFocus, option } = this.props

    if (isFocused) return

    onFocus(option, event)
  }

  render () {
    const {
      children,
      className,
      option: { title, item }
    } = this.props

    const attributes = map(item, (value, key) => (
      <p key={key} className="col-11" style={{ marginBottom: '0.25rem', marginTop: '0' }}>
        <small>
          <b>
            {`${startCase(key)}: `}
          </b>
          <br />
          {value || <br />}
        </small>
      </p>
    ))

    return (
      <div
        className={className}
        title={title}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
      >
        <b>{children}</b>
        <div className="row">
          {attributes}
        </div>
      </div>
    )
  }
}

/* eslint-disable-next-line react/no-multi-comp */
class NewConcernModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = ({
      ...props,
      errors: [],
      processing: false
    })
  }

  componentDidMount () {
    const {
      ticket: { client_id },
      concerns
    } = this.state

    this.setState({ processing: true })

    cloudhelpGet('/api/cmdb/items', { client_id })
      .then(({ data }) => {
        const { errors } = this.state

        if (isEmpty(data)) {
          return this.setState({ errors: concat(errors, ['This client has no items']) })
        }

        if (isEmpty(differenceWith(data, concerns, isEqual))) {
          return this.setState({ errors: concat(errors, ['All client\'s items have been added']) })
        }

        return map(differenceWith(data, concerns, isEqual), item => ({
          label: truncate(`${item.name} - ${item.description}`, { length: '50', separator: ' ' }),
          value: item.configuration_item_id,
          item: { ...item }
        }))
      })
      .then(items => this.setState({ options: items, processing: false }))
  }

  onSubmit = () => {
    this.setState({ processing: true })

    const {
      value,
      concerns,
      afterSubmit
    } = this.state

    const updatedConcerns = unionWith(concerns, map(value, 'item'), isEqual)

    const params = {
      concerns: updatedConcerns
    }

    cloudhelpPatch(`/api${window.location.pathname}/impact_concerns/update`, params)
      .then(({ data }) => { afterSubmit(data) })
  }

  filterOptions = (opts, stringFilter, currentOptions) => {
    const filteredOptions = filter(opts, ({ item }) => {
      const searchableString = lowerCase(values(item).join())

      return includes(searchableString, lowerCase(stringFilter))
    })

    return differenceWith(filteredOptions, currentOptions, isEqual)
  }

  render () {
    const {
      errors,
      options,
      processing,
      value
    } = this.state

    return (
      <Modal {...this.props} processing={processing} title="Add concerns">
        { some(errors) && (
          <Alert alertType="error" showAlert>
            <ErrorList errors={errors} />
          </Alert>
        )}
        <Select
          closeOnSelect={false}
          disabled={some(errors)}
          menuContainerStyle={{ maxHeight: '500px' }}
          menuStyle={{ maxHeight: '500px' }}
          multi
          name="resources"
          onChange={selectedValue => this.setState({ value: selectedValue })}
          onSelectResetsInput={false}
          optionComponent={ImpactConcernOption}
          options={options || []}
          value={value}
          filterOptions={this.filterOptions}
        />
        <button
          type="submit"
          className="button"
          disabled={some(errors)}
          onClick={this.onSubmit}
        >
          Add concerns
        </button>
      </Modal>
    )
  }
}

export default NewConcernModal
